module.exports = __webpack_public_path__ + "media/images/pokerroom/lotos/description-pict-fe9c02cc13f44985632c3852c5a73a66.jpg";